// ReusableModal.js
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wraps modal content
 * 
 * @param {Boolean} isOpen 
 * @param {Function} onClose 
 * @param {string} size 
 * @param {string} title 
 * 
 * @returns {JSX.Element}
 */
const ModalWrapper = ({ isOpen, onClose, children, size = 'medium', title }) => {
  if (!isOpen) return null;

  const modalSize = {
    small: 'w-1/4',
    medium: 'w-3/4 md:w-1/2 max-w-2xl',
    large: 'w-3/4',
  };

  return (
    <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className={`bg-white rounded-lg shadow-lg ${modalSize[size]} p-6 relative`}
      >
        {title && <h2 className="text-lg font-bold mb-4">{title}</h2>}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          ✖
        </button>
        <div className="modal-content">{children}</div>
      </div>
    </div>
  );
};

ModalWrapper.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  title: PropTypes.string,
};

export default ModalWrapper;
